import script from "./BaseDate.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseDate.vue?vue&type=script&setup=true&lang=js"

import "./BaseDate.vue?vue&type=style&index=0&id=3c226109&lang=scss"

const __exports__ = script;

export default __exports__